import React, {useState} from 'react'
import './Modal.css';
import {RxCross2} from 'react-icons/rx';
import {LuFileUp, LuFile} from 'react-icons/lu';

const Modal = ({showBakcDrop, modal, hideModal, children, className}) => {

	const [num, setNum] = useState();

	const handleFileUpload = async () =>{

	}

	return (
		<>
			<div className={`back-drop ${showBakcDrop && 'show-backdrop'}`}></div>

			<div className={`modal app-flex ${modal && 'show_modal'} ${className}`}>

				<div className="flex" style={{height:"20px", justifyContent:"flex-end", width:"100%"}}><RxCross2 className="cross-icon" onClick={()=>{hideModal()}}/></div>
				
				{children}
				
			</div>
		</>
	)
}

export default Modal